module.exports = __webpack_public_path__ + "img/change_logo_banner.42f49aad.webp";